/**
 * Function to Download Excel file
 */
export function downloadExcelFile(response: Blob, fileName: string) {
  const downloadLink = document.createElement('a')

  downloadLink.href = window.URL.createObjectURL(response)
  downloadLink.download = `${fileName}.xlsx`

  document.body.appendChild(downloadLink)
  downloadLink.click()

  document.body.removeChild(downloadLink)
}
